import api from './api';
import { Pagination, StoreCategory, StoreColor, StoreCatalogFilter, StoreCatalogItem, StoreProductDetail, StoreSeller, StoreProfile, StoreOrder, UpdateProfileRequest, CreateOrderRequest, UpdateStoreOrderRequest } from '../models';

export const storeService = {
  getCatalog: (filter: StoreCatalogFilter) =>
    api.get<Pagination<StoreCatalogItem>>('/store/catalog', { params: filter }).then((r) => r.data),

  getProduct: (id: number) =>
    api.get<StoreProductDetail>(`/store/products/${id}`).then((r) => r.data),

  getSellers: () =>
    api.get<StoreSeller[]>('/store/sellers').then((r) => r.data),

  getCategories: () =>
    api.get<StoreCategory[]>('/store/categories').then((r) => r.data),

  getColors: () =>
    api.get<StoreColor[]>('/store/colors').then((r) => r.data),

  getProfile: () =>
    api.get<StoreProfile>('/store/profile').then((r) => r.data),

  updateProfile: (data: UpdateProfileRequest) =>
    api.put<boolean>('/store/profile', data).then((r) => r.data),

  getOrders: () =>
    api.get<StoreOrder[]>('/store/orders').then((r) => r.data),

  createOrder: (data: CreateOrderRequest) =>
    api.post<number>('/store/orders', data).then((r) => r.data),

  updateOrder: (id: number, data: UpdateStoreOrderRequest) =>
    api.put<void>(`/store/orders/${id}`, data).then((r) => r.data),

  cancelOrder: (id: number) =>
    api.delete<void>(`/store/orders/${id}`).then((r) => r.data),

  lookupCustomer: (phone: string) =>
    api
      .get<{ maskedName: string; city: string }>('/store/customers/lookup', {
        params: { phone: phone.replace(/\D/g, '') },
      })
      .then((r) => r.data),

  lookupCep: (zipCode: string) =>
    api.get<{
      street: string;
      neighborhood: string;
      city: string;
      state: string;
      zipCode: string;
      complement?: string;
    }>(`/addresses/${zipCode.replace(/\D/g, '')}`).then((r) => r.data),
};
